import {
  DatalayerPopupContentTypes,
  DataLayerTrackEvents,
  IMPRESSION_POPUP_EVENT_NAME,
} from '@/datalayer/App.datalayer.constants';
import { getDataLayerPageLoadMetadata } from '@/hooks/useDataLayerPageLoad';
import React, { useCallback } from 'react';
import TagManager from 'react-gtm-module';
import { PrivacyConsentValues } from './PortalPrivacyConsent.interface';

const DATALAYER_CONSENT_POSITION = 'preferences_settings';
const DATALAYER_CONSENT_TYPE = 'toggle';

export const usePortalPrivacyConsentDatalayer = () => {
  const isImpressed = React.useRef(false);

  const emitImpressionPopup = useCallback((title) => {
    if (isImpressed.current) return;

    const dataLayer = {
      event: DataLayerTrackEvents.IMPRESSION_POPUPS,
      event_name: IMPRESSION_POPUP_EVENT_NAME,
      ...(!!title && { title }),
      content_type: DatalayerPopupContentTypes.PRIVACY_CONSENT,
    };
    setTimeout(() => {
      TagManager.dataLayer({ dataLayer });
    });
    isImpressed.current = true;
  }, []);

  const emitToggleConsent = useCallback((props: { given: boolean }) => {
    const sessionMetadata = getDataLayerPageLoadMetadata();

    const dataLayer = {
      event: props.given ? 'trackEvent-portalConsentAccepted' : 'trackEvent-portalConsentDecline',
      event_name: props.given
        ? 'portal_tracking_consent_accepted'
        : 'portal_tracking_consent_decline',
      position: DATALAYER_CONSENT_POSITION,
      type: DATALAYER_CONSENT_TYPE,
      ...sessionMetadata,
      portal_tracking_status: props.given
        ? PrivacyConsentValues.CONSENT_ACCEPTED
        : PrivacyConsentValues.CONSENT_REJECTED,
    };

    setTimeout(() => {
      TagManager.dataLayer({ dataLayer });
    });
  }, []);

  return {
    emitImpressionPopup,
    emitToggleConsent,
  };
};
